import mitt from "mitt";
import type { OpenModalEventPayload, NoteSaveEventPayload, ModalStateChangeEventPayload } from "../src/types/modal.types";

export type ApplicationEvents = {
    // Modal events
    "open-modal": OpenModalEventPayload;
    "close-modal": void;
    "modal:state-change": ModalStateChangeEventPayload;

    // Note events
    "note:save": NoteSaveEventPayload;

    // Loading events from razor
    "load-start": void;
    "load-stop": void;

    // Create new calculation
    "calculation:create": {
        lang: string;
        projectUid: undefined | string;
    };

    // Error-events
    "error:create": {
        label: string;
        message: string;
    };

    // Success-events
    "success:create": {
        label: string;
        message: string;
    };

    "log-out": {
        title: string;
        message: string;
    };

    //Project has been deleted
    "project:deleted": void;

    //Calculation has been deleted
    "calculation:deleted": void;

    // Calculation (and optionally its project) has been renamed from inside the calculator
    "calculation:renamed": {
        calculationUid: string;
        calculationName: string;
        projectName: string | null;
    };

    "modalmanager:ready": void;

    "show:terms": void;
    "close:terms": void;

    // Tooltip coordination
    "tooltip:opened": string;

    // Link calculator: indexes of opening types with an invalid plank depth (from submit validation)
    "link:invalid-plank-depths": number[];
};

const emitter = mitt<ApplicationEvents>();

// Debug wrapper omkring emitteren - hvis der skal debugges, ændre const emitter-linjen til: const originalEmitter = mitt<ApplicationEvents>();
// const emitter = {
//   ...originalEmitter,
//   on: (type: string, handler: any) => {
//     console.log(`[EVENT-BUS] Listener registreret for "${type}" event`, { timestamp: new Date().toISOString() });
//     return originalEmitter.on(type, handler);
//   },
//   off: (type: string, handler: any) => {
//     console.log(`[EVENT-BUS] Listener fjernet for "${type}" event`, { timestamp: new Date().toISOString() });
//     return originalEmitter.off(type, handler);
//   },
//   emit: (type: string, event?: any) => {
//     console.log(`[EVENT-BUS] Event "${type}" emitteret`, { event, timestamp: new Date().toISOString() });
//     return originalEmitter.emit(type, event);
//   },
//   all: originalEmitter.all,
// };

// console.log('[EVENT-BUS] Event bus initialiseret');

export default emitter;
